"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SharedImageBanner;
const react_1 = __importDefault(require("react"));
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const SharedImageBanner_module_scss_1 = __importDefault(require("./SharedImageBanner.module.scss"));
const buildImageUrl_1 = require("../../utils/buildImageUrl");
function SharedImageBanner({ title, description, textColour, ctaLink, ctaText, clickUrl, accessibilityText, desktopImage, impressionUrl, associatedAdvertId, logoImage, logoAccessibilityText, logo2Image, logo2AccessibilityText, previewerSize, esiType, testId = "shared", }) {
    const mobileSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "599",
        sm: "aspect",
        aspect: "4:5",
    }, { applyPoi: true });
    const tabletSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "1279",
        sm: "aspect",
        aspect: "3:1",
    }, { applyPoi: true });
    const desktopSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "2560",
        sm: "aspect",
        aspect: "4:1",
    }, { applyPoi: true });
    const textColourClass = textColour === "Light" ? SharedImageBanner_module_scss_1.default.light : "";
    const previewerImageSrc = previewerSize === "mobile"
        ? mobileSrc
        : previewerSize === "tablet"
            ? tabletSrc
            : desktopSrc;
    const imageContainerClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.imageContainer;
    const contentContainerClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-contentContainer-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.contentContainer;
    const titleClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-title-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.title;
    const descriptionClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-description-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.description;
    const smallCtaContainerClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-smallCtaContainer-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.smallCtaContainer;
    const largeCtaContainerClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-largeCtaContainer-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.largeCtaContainer;
    const logosContainerClassName = previewerSize
        ? SharedImageBanner_module_scss_1.default[`preview-logosContainer-${previewerSize}`]
        : SharedImageBanner_module_scss_1.default.logosContainer;
    return (react_1.default.createElement("a", { href: ctaLink, "data-testid": `${testId}-image-banner-link`, onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
                esiType,
            });
        }, className: SharedImageBanner_module_scss_1.default.bannerLink },
        react_1.default.createElement("div", { className: imageContainerClassName },
            previewerSize ? (react_1.default.createElement("img", { "data-testid": `${testId}-image-banner-main-image`, src: previewerImageSrc, alt: accessibilityText })) : (react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { media: "(min-width: 1280px)", srcSet: desktopSrc }),
                react_1.default.createElement("source", { media: "(min-width: 600px)", srcSet: tabletSrc }),
                react_1.default.createElement("img", { "data-testid": `${testId}-image-banner-main-image`, src: mobileSrc, alt: accessibilityText }))),
            react_1.default.createElement("div", { className: contentContainerClassName },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { "data-testid": `${testId}-image-banner-title`, className: `${titleClassName} ${textColourClass}` }, title),
                    react_1.default.createElement("p", { "data-testid": `${testId}-image-banner-description`, className: `${descriptionClassName} ${textColourClass}` }, description),
                    react_1.default.createElement("div", { className: smallCtaContainerClassName },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", className: textColourClass, labelText: ctaText, "data-testid": `${testId}-image-banner-small-cta` })),
                    react_1.default.createElement("div", { className: largeCtaContainerClassName },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", className: textColourClass, labelText: ctaText, "data-testid": `${testId}-image-banner-large-cta` })))),
            react_1.default.createElement("div", { className: logosContainerClassName },
                react_1.default.createElement("img", { src: logoImage, alt: logoAccessibilityText, "data-testid": `${testId}-image-banner-logo` }),
                logo2Image ? (react_1.default.createElement("img", { alt: logo2AccessibilityText || "", src: logo2Image, "data-testid": `${testId}-image-banner-logo-2` })) : null))));
}
